import {
  DiscoveryType,
  JoinedDiscoveryData,
  DurationTrendDiscovery,
  ErrorRateTrendDiscovery,
  InvocationsTrendDiscovery,
} from '@hud/portal-dtos/webapp-overview.dto';

// Helper function to sort by trend
export function sortByTrend<T extends { trend?: number | null }>(items: T[]): T[] {
  return [...items].sort((a, b) => {
    const trendA = a.trend ?? 0;
    const trendB = b.trend ?? 0;
    return trendB - trendA;
  });
}

export function sortDiscoveryData(
  data: JoinedDiscoveryData,
  discoveryType: DiscoveryType,
): JoinedDiscoveryData {
  let sortedData = data;

  // Handle each trend type separately
  if (discoveryType === DiscoveryType.DurationTrend) {
    const typedData = data as DurationTrendDiscovery;
    sortedData = {
      functions: sortByTrend(typedData.functions),
      endpoints: sortByTrend(typedData.endpoints),
      queues: sortByTrend(typedData.queues),
    };
  } else if (discoveryType === DiscoveryType.ErrorRateTrend) {
    const typedData = data as ErrorRateTrendDiscovery;
    sortedData = {
      functions: sortByTrend(typedData.functions),
      endpoints: sortByTrend(typedData.endpoints),
      queues: sortByTrend(typedData.queues),
    };
  } else if (discoveryType === DiscoveryType.InvocationsTrend) {
    const typedData = data as InvocationsTrendDiscovery;
    sortedData = {
      functions: sortByTrend(typedData.functions),
      endpoints: sortByTrend(typedData.endpoints),
      queues: sortByTrend(typedData.queues),
    };
  }

  return sortedData;
}
